import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Clock, BookOpen } from "lucide-react";
import { Itinerario } from "@/data/itinerarios";

interface ItinerarioCardProps {
  itinerario: Itinerario;
}

const ItinerarioCard = ({ itinerario }: ItinerarioCardProps) => {
  const totalArticles = itinerario.steps.reduce(
    (acc, step) => acc + step.articleIds.length,
    0
  );

  return (
    <Link to={`/cursos/${itinerario.id}`} className="group block">
      <div className="relative p-8 md:p-10 rounded-2xl bg-secondary/20 hover:bg-secondary/40 transition-all duration-300 h-full flex flex-col">
        {/* Badge Gratis */}
        <Badge variant="secondary" className="absolute top-6 right-6 text-xs font-medium bg-primary/10 text-primary border-0">
          Gratis
        </Badge>

        {/* Icon */}
        <div className="mb-6">
          <itinerario.icon className="h-10 w-10 text-foreground" />
        </div>

        {/* Title */}
        <h3 className="text-2xl md:text-3xl font-light text-foreground leading-tight mb-3 group-hover:text-primary transition-colors">
          {itinerario.title}
        </h3>

        {/* Description */}
        <p className="text-base text-muted-foreground font-light leading-relaxed mb-6 flex-1">
          {itinerario.description}
        </p>

        {/* Meta */}
        <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
          <span className="flex items-center gap-1.5">
            <Clock className="h-4 w-4" />
            {itinerario.totalTime}
          </span>
          <span className="flex items-center gap-1.5">
            <BookOpen className="h-4 w-4" />
            {itinerario.steps.length} pasos
          </span>
          <span className="text-xs">
            {totalArticles} artículos incluidos
          </span>
        </div>

        {/* Difficulty */}
        <div className="mt-4 pt-4 border-t border-border/50">
          <span className="text-xs text-muted-foreground">
            Dificultad: <span className="font-medium text-foreground">{itinerario.difficulty}</span>
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ItinerarioCard;
